import Web3 from "web3";
import ECommerce from "../build/contracts/ECommerceTransactions.json";
import { useState, useEffect } from "react";
import { clearCart } from '../store/cartReducer';
import { useDispatch } from 'react-redux'
const useBlockChainData = () => {

  const [storefront, setStorefront] = useState(null);
  const [loading, setLoading] = useState(true);
  const [account, setAccount] = useState("");
  const [productCount, setProductCount] = useState(0);
  const [products, setProducts] = useState([]);

  const sellerAddress = process.env.REACT_APP_SELLER_ADDRESS;

  useEffect(() => {
    initializeWeb3();
    fetchBlockchainData();
  }, []);

  const initializeWeb3 = async () => {
    if (window.ethereum) {
      window.web3 = new Web3(window.ethereum);
      await window.ethereum.enable();
    } else {
      // window.web3 = new Web3(new Web3.providers.HttpProvider("http://147.135.97.220:8545")); // Connect to Ganache RPC URL
      window.web3 = new Web3(window.web3.currentProvider);
    }
  };

  const fetchBlockchainData = async () => {
    const web3 = window.web3;
    const getAccounts = await web3.eth.getAccounts();
    setAccount(getAccounts[0]);

    const networkId = await web3.eth.net.getId();
    const networkDetail = ECommerce.networks[networkId];

    if (networkDetail) {
      const eCommerceInstance = new web3.eth.Contract(ECommerce.abi, networkDetail.address);
      setStorefront(eCommerceInstance);

      setLoading(false);
    } else {
      window.alert("eCommerce contract has not been deployed to the network.");
    }
  };

  const purchaseProduct = async (items, userData) => {
    try {
      setLoading(true);
      const web3 = window.web3;
      const productIds = items.map(item => item.productId);
      const productNames = items.map(item => item.name);
  
      const combinedProductIds = productIds.join("_");
      const combinedProductName = productNames.join("_");
  
      const totalValue = items.reduce((acc, item) => acc + item.price * item.quantity, 0);
  
      console.log("Total Value (ETH):", totalValue);
      const valueInWei = web3.utils.toWei(totalValue.toString(), "ether");
      console.log("Total Value (WEI):", valueInWei);
  
      const accounts = await web3.eth.getAccounts();
      const buyerAccount = accounts[0];
  
      let userId = "null";
      let userName = "guest";
      if (userData.isLoggedIn) {
        userId = userData.user.id;
        userName = userData.user.name;
      }
  
      const options = { from: buyerAccount, value: valueInWei };
      console.log("options", options);
  
      // Get gas price
      const gasPrice = await web3.utils.toWei("20", "gwei");  
     
      const response = await storefront.methods
        .recordTransaction(
          buyerAccount,
          sellerAddress,
          valueInWei,
          combinedProductIds,
          combinedProductName,
          userId,
          userName
        )
        .send({
          from: buyerAccount,
          value: valueInWei,
          gasPrice: gasPrice  
        });
  
        response['basePrice'] = totalValue.toString();
        response['items'] = items;
      console.log("Transaction successful:", response);
      return response;
    } catch (error) {
      if (error.code === 4001) { 
        console.error("User canceled the transaction.");
        alert("Transaction was canceled by the user.");
      } else {
        console.error("Transaction failed:", error);
      }
    } finally {
      setLoading(false);
    }
  };

  return {
    purchaseProduct
  };
};

export default useBlockChainData;
